import React from "react";
import { usePage } from "@inertiajs/react";
import useTranslation from "@hooks/use_translation";
import TaskCard from "./TaskCard";
import type { Task } from "@/types/task";

interface TaskCardProps {
  task: Task;
}

const SetupWorkPreference: React.FC<TaskCardProps> = ({ task }) => {
  const { t } = useTranslation("tasks");
  const { uploadResumeModal } = usePage<{ uploadResumeModal?: boolean }>().props;

  let description;
  let actionText;
  if (uploadResumeModal) {
    description = t("workPreferences.descriptionUploadResumeModal");
    actionText = t("workPreferences.completeProfileUploadResumeModal");
  } else {
    description = t("workPreferences.description");
    actionText = t("workPreferences.completeProfile");
  }

  return (
    <TaskCard
      task={task}
      title={t("workPreferences.title")}
      description={description}
      actionHref="/work_preferences"
      actionText={actionText}
      externalLink={false}
    />
  );
};

export default SetupWorkPreference;
